import { useEffect, useLayoutEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { usePageLoading } from "../context/PageLoadingContext";
import { VALID_COUNTRY_PREFIXES } from "../helper/isHomeRoute";

function GeoRedirect() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setPageLoading } = usePageLoading();

  const pathParts = location.pathname.split("/").filter(Boolean);
  const needsRedirect = !VALID_COUNTRY_PREFIXES.includes(pathParts[0]);

  useLayoutEffect(() => {
    if (needsRedirect) {
      setPageLoading(true);
    }
  }, [needsRedirect, setPageLoading]);

  useEffect(() => {
    if (!needsRedirect) return;

    const checkLocation = async () => {
      try {
        const res = await fetch(
          `https://ipinfo.io/json?token=${process.env.REACT_APP_IPINFO_KEY}`
        );
        const data = await res.json();
        const country = data?.country === "AE" ? "ae" : "eg";
        const newPath = `/${country}${location.pathname}${location.search}${location.hash}`;
        navigate(newPath, { replace: true });
      } catch (error) {
        console.error("Location fetch failed:", error);
        const newPath = `/eg${location.pathname}${location.search}${location.hash}`;
        navigate(newPath, { replace: true });
      }
    };

    checkLocation();
  }, [navigate, location, needsRedirect]);

  return null;
}

export default GeoRedirect;
